export const responseDataLakeEncryption = {
  data: {
    attributes: {
      connectionString: 'AQICAHjIV9pasxFCwcl96XQ9T7SI448IVp1d2JwsMZkDhJARcwGMI4IbrUaHQBJRD+LEffZqAAABKDCCASQGCSqGSIb3DQEHBqCCARUwggERAgEAMIIBCgYJKoZIhvcNAQcBMB4GCWCGSAFlAwQBLjARBAx7Rll49RcsQ/eo6YcCARCAgdy4PWQ4ldGqMaTOVXeMe6A4NSb2lDn4sK8gOAv275j5UDwl0N2nppp6CRTRentLFXQIrYzqF1j8x7/j4QQEXsxIzbPPcQ9NqCUXYfjmuy7geXi8g2LPD7hpfuNpRUz0nQ4+rpi5aA6EDcP/aKf+OntLDJ9ZME5z81XKmbeBIiXOXV3XTsUiVoAK8u2KhjffjMu4S0qxEa4fF/0OMShLVPR3SMXOCSETVlBlpvjNVpNexah+HBBjJgAYS1u+Qn177+79rIh49/mWlqg5PrTDqNOGJG6YhO6Dpc2Ds6Jr'
    }
  }
};